import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import PageMeta from '@/components/feature/PageMeta';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { getArticlesByCategory, getCategoryBySlug, categories, getLatestArticles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || '');
  const categoryArticles = getArticlesByCategory(slug || '');
  const [activeCategory, setActiveCategory] = useState(slug || '');

  const displayArticles = activeCategory
    ? getArticlesByCategory(activeCategory)
    : getLatestArticles(12);

  const activeCat = getCategoryBySlug(activeCategory);

  if (!category && slug) {
    return (
      <>
        <ScrollToTop />
        <PageMeta
          title="分类未找到 - 黑料中文网"
          description="抱歉，您访问的分类页面不存在。请查看其他娱乐爆料分类。"
          keywords="黑料中文网,分类,娱乐爆料"
          canonicalUrl={`https://fuxiaoxiao.cn/category/${slug}`}
        />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 rounded-full bg-background-100">
              <i className="ri-emotion-sad-line text-3xl text-foreground-300"></i>
            </div>
            <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-3">分类未找到</h1>
            <p className="text-foreground-500 mb-6">抱歉，您访问的分类页面不存在</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer"
            >
              返回首页
            </Link>
          </div>
        </div>
      </>
    );
  }

  const pageTitle = activeCat
    ? `${activeCat.name} - 黑料中文网`
    : '全部分类 - 黑料中文网';
  const pageDesc = activeCat
    ? `${activeCat.description}，共${activeCat.articleCount}篇独家爆料内容。黑料中文网 - 最新娱乐黑料爆料平台。`
    : '浏览黑料中文网所有分类内容，包括明星爆料、网红内幕、综艺真相、影视黑幕、音乐圈乱象、时尚圈潜规则等。';

  return (
    <>
      <ScrollToTop />
      <PageMeta
        title={pageTitle}
        description={pageDesc}
        keywords={`黑料中文网,${activeCat ? activeCat.name + ',' : ''}娱乐爆料,明星黑料,网红内幕,分类浏览`}
        canonicalUrl={`https://fuxiaoxiao.cn/category/${activeCategory || ''}`}
      />

      <main className="pt-20 pb-14 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: activeCat ? activeCat.name : '全部分类' },
              ]}
            />
          </div>

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              {activeCat ? activeCat.name : '全部分类'}
            </h1>
            {activeCat && (
              <p className="text-sm text-foreground-500">{activeCat.description}</p>
            )}
          </div>

          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
            <Link
              to="/category/all"
              onClick={() => setActiveCategory('')}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                !activeCategory
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:text-foreground-900 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              全部
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setActiveCategory(cat.slug)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:text-foreground-900 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                {cat.name}
                <span className="ml-1.5 text-xs opacity-70">({cat.articleCount})</span>
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {displayArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>

          {displayArticles.length === 0 && (
            <div className="text-center py-16">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-100 text-foreground-300">
                <i className="ri-inbox-line text-2xl"></i>
              </div>
              <p className="text-foreground-500">该分类暂无文章，请查看其他分类</p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}